import type { CategoryTileViewModel } from '@rocco/ui/tile-category/view-models/category';
import { mapProfessionalCategoriesToLinkGridItems } from '~/modules/professionals-category/util/map-professional-categories-to-link-grid';
import CategoryPageLinkGrid from '@ui-rocco/pages/category-page/CategoryPageLinkGrid';

interface ProfessionalCategoryExploreSectionProps {
    categories: CategoryTileViewModel[];
    title: string;
    isRoot: boolean;
}

/**
 * Contextual professional category links for directory pages. Reuses the location
 * mesh layout so bottom-of-page internal links stay visually consistent.
 */
const ProfessionalCategoryExploreSection = ({
    categories,
    title,
    isRoot,
}: ProfessionalCategoryExploreSectionProps) => {
    const items = mapProfessionalCategoriesToLinkGridItems(categories, isRoot);

    return (
        <CategoryPageLinkGrid
            heading={title}
            items={items}
            stackedAfterMeshSection
        />
    );
};

export default ProfessionalCategoryExploreSection;
